// utils/templateIdMap.js
//
// Single source of truth for translating between the frontend's template KEY
// ("template1", "template1freeversion", …) and the backend's numeric
// `availableTemplateId` stored on the Template document.
//
// These two mappings used to be written inline in opposite directions in
// Selection.jsx and user-masjidWeb.jsx and had drifted: the free version was
// posted as id 2 (template2!) and read back as "template1freeversion", so a user
// who saved a free site could be sent to the wrong template on their next visit.
// Keeping both directions here means they can never disagree again.

export const TEMPLATE_KEY_TO_ID = {
  template1: 1,
  template2: 2,
  template1freeversion: 3,
  // A website built from a prompt (pages/ai-site-builder).
  aiSite: 4,
};

export const TEMPLATE_ID_TO_KEY = {
  1: "template1",
  2: "template2",
  3: "template1freeversion",
  4: "aiSite",
};

/** Frontend key -> backend availableTemplateId (defaults to template1). */
export const toBackendTemplateId = (templateKey) =>
  TEMPLATE_KEY_TO_ID[templateKey] || 1;

/** Backend availableTemplateId -> frontend key (defaults to the free version). */
export const fromBackendTemplateId = (id) =>
  TEMPLATE_ID_TO_KEY[Number(id)] || "template1freeversion";
